function throttle(fn, wait) {
  let lastTime = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastTime < wait) return;
    lastTime = now;
    return fn(...args);
  };
}

document.addEventListener('DOMContentLoaded', function () {
  const rollTextSections = document.querySelectorAll('.roll-text');

  function updateSpanVisibility() {
    rollTextSections.forEach((section) => {
      const spans = section.querySelectorAll('.roll-text__title span');
      const sectionStart = section.getBoundingClientRect().top + window.scrollY;
      const sectionHeight = section.offsetHeight;
      const triggerHeight = sectionHeight / spans.length;

      spans.forEach((span, index) => {
        const adjustedStart = sectionStart + triggerHeight * index - window.innerHeight * 0.3; // Adjust this factor to control the timing
        if (window.scrollY >= adjustedStart && window.scrollY < adjustedStart + triggerHeight) {
          span.classList.add('visible');
        } else {
          span.classList.remove('visible');
        }
      });
    });
  }

  const throttledScrollHandler = throttle(function () {
    window.requestAnimationFrame(updateSpanVisibility);
  }, 100);

  window.addEventListener('scroll', throttledScrollHandler);
});
